<template>
  <v-toolbar-items v-if="!list" class="hidden-sm-and-down">
    <v-btn v-for="item in links" flat v-if="item.visible" :key="item.name" :to="item.to">{{item.name}}</v-btn>
  </v-toolbar-items>
  <v-list v-else dense>
    <v-list-tile v-if="item.visible" v-for="item in links" :key="item.name" :to="item.to" v-tooltip="{content: mini ? item.name : null}">
      <v-list-tile-action >
        <v-icon >{{item.icon}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content >
        <v-list-tile-title>{{item.name}}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    mini: Boolean,
    list: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isTrainer', 'isRunner', 'authUser']),
    links () {
      return [
        {visible: true, to: {name: 'trainer-data', params: {id: this.authUser.id}}, name: 'Dane', icon: 'person'},
        {visible: true, to: {name: 'trainer-runners', params: {id: this.authUser.id}}, name: 'Zawodnicy', icon: 'directions_run'},
        {visible: true, to: {name: 'trainer-videos', params: {id: this.authUser.id}}, name: 'Filmy', icon: 'movie'},
        {visible: true, to: {name: 'trainer-pages', params: {id: this.authUser.id, slug: 'discounts'}}, name: 'Zniżki', icon: 'card_giftcard'},
        {visible: true, to: {name: 'trainer-pages', params: {id: this.authUser.id, slug: 'explanations'}}, name: 'Objaśnienia', icon: 'contact_support'},
        {visible: true, to: {name: 'trainer-notifications', params: {id: this.authUser.id}}, name: 'Powiadomienia', icon: 'notifications'},
        {visible: true, to: {name: 'trainer-forum', params: {id: this.authUser.id}}, name: 'Forum', icon: 'forum'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/TrainerNav.vue